<template>
  <div class="w-full flex items-center gap-1.5 p-1.5 rounded-md bg-neutral-10 cursor-default">
    <SolidImageIcon />
    <BaseText type="label" size="xs" class="text-text-muted">
      Beta
    </BaseText>
    <BaseText type="body" size="xs" class="text-text-muted">
      Image Ads Only
    </BaseText>
  </div>
</template>

<script>
import SolidImageIcon from '../../globals/Icons/FilterIcons/SolidImageIcon.vue'

export default {
  name: 'ImageAdsOnlyDisclaimer',
  components: {
    SolidImageIcon
  }
}
</script>